import React from 'react'
import ReactDOM from 'react-dom/client'
import { setupStore } from 'app/store'
import { Provider } from 'react-redux'
import App from 'app/index'

const store = setupStore()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)
